const TestimoData = [
    {
        img: "/assets/images/kwikengage/firebolt.png",
        state: "INDIA",
        content: "KwikEngage has helped us cut our customer acquisition cost by 40% by setting up a robust two-way marketing plan. Through their intervention, we were able to successfully generate over 3.42 lakh leads in just 45 days. We also saw 2X increase in abandoned cart recovery. We’re highly impressed with KwikEngage’s solutions and the results they’ve delivered.",
        author: "— Arnav Kishore, Founder & CEO, Fire-Boltt",
        size: { width: "120px", height: "45px" }  // Custom size
    },
    {
        img: "/assets/images/kwikengage/trueelements.png",
        state: "INDIA",
        content: `Kwik Chat has been a game changer for True Elements. Since the very beginning Kwik Chat has relentlessly helped us solve many of our pressing issues. In just a couple of months, we’ve seen a jump of 134% in abandonment cart recovery rate. We’re happy and hope to see these numbers grow in the coming years.`,
        author: "— Puru Gupta, Co-Founder & CEO, True Elements",
        size: { width: "60px", height: "50px" }  // Custom size
    },
    {
        img: "/assets/images/kwikengage/amydus.png",
        state: "INDIA",
        content: `Working with KwikEngage has been very fruitful for us. Ever since we’ve started using KwikEngage’s solutions, we’ve increased our customer retention by about 85% and abandoned cart recoveries by 17.67% month-on-month. We highly recommend KwikEngage to everyone and hope to unlock more growth with them.`,
        author: "— Kartik Sapra, Co-founder, Amydus",
        size: { width: "100px", height: "52px" }  // Custom size
    }
]

export const SectionSix = () => {
    return (
        <div className='section-6'>
            <div className="container-fluid">
                <div className="sec-heading">
                    <h1>Success Stories</h1>
                </div>
                <p style={{ fontWeight: "100", color: "#FFFFFF60" }} className='mb-4'>What Our Merchants Say: Real Results, Real Growth</p>
                
                <div className="d-flex flex-wrap justify-content-center gap-3 overflow-x-auto">
                    {TestimoData.map((item, index) => (
                        <div key={index} className="Testimo-Cards px-4 py-3 text-white  flex-column">
                            {/* Logo & Country Section */}
                            <div className="d-flex align-items-center justify-content-between" style={{ width: "100%" }}>
                                <img
                                    src={item.img}
                                    alt="logo"
                                    className="me-2"
                                    style={{ width: item.size.width, height: item.size.height, objectFit: "contain" }} // Individual sizes
                                />
                                <p style={{ fontWeight: 100, opacity: "0.6", fontSize: '14px', marginTop: '10px' }}>{item.state}</p>
                            </div>
                            
                            {/* Content */}
                            <div className="mt-3 text-start" style={{ fontSize: '14px', textAlign: 'left', lineHeight: "1.5",width:"300px" }}>
                                <span dangerouslySetInnerHTML={{ __html: item.content }} />
                            </div>

                            <div className="mt-3 text-start" style={{ fontSize: '14px', textAlign: 'left', lineHeight: "1.5", fontWeight:"lighter" ,color:"rgba(255, 255, 255, 0.376)" }}>
                                <span dangerouslySetInnerHTML={{ __html: item.author }} />
                            </div>
                        </div>
                        


                    ))}
                </div>
                 {/* CTA Section */}
                 <div className="last-section-six row d-flex align-items-center justify-content-between pb-0">
                    <div className="view col-lg-8 d-flex align-items-center">
                        <div className="view-img1">
                            <img
                                src="/assets/images/kwikpass/view.png"
                                alt="Customer Engagement"
                                width={170}
                            />
                        </div>
                        <div className="view-text1  mb-3"> {/* Reduced margin */}
                            <h4>Ready to Transform Your Customer Engagement?</h4>
                            <p className="text-wrap">
                            Join leading eCommerce brands using Kwik Engage to capture, engage, and convert more customers.
                            </p>
                        </div>
                    </div>
                    <div className="cta-container1 col-lg-3 text-end mb-3 p-0 ">
                        <a href="https://www.gokwik.co/contact?utm_source=productpage&utm_medium=KwikPass" target='_blank'>
                            <button className="cta">Get Started Now</button>
                        </a>
                    
                </div>
                </div>
            </div>
        </div>
    )
}
